import type { UiPreferences } from "./useUiPreferences";

/** Gespeicherter Zustand der Stelle; `undefined` = nie umgeschaltet, dann gilt die Vorgabe des Abschnitts. */
export function storedFormSectionCollapsed(prefs: UiPreferences, sectionKey: string): boolean | undefined {
  const value = prefs.collapsedFormSections?.[sectionKey];
  return typeof value === "boolean" ? value : undefined;
}
